module.exports = __webpack_public_path__ + "img/caret-right.d7b42ff2.svg";